import React from "react";
import lxwConstants from "../config/lexworkplace-constants";
import buildData from "../buildData/buildData";
import {
	IconFolderFilled,
	IconFolderSymlink,
	IconBriefcase,
	IconNote,
	IconLogin2,
	IconUserX,
	IconLogout,
	IconLockOpen,
	IconFile,
	IconMail,
	IconUsersGroup,
} from "@tabler/icons-react";
import { getFileIconMap } from "./iconMap";
const errorCodes = lxwConstants.errorCodes;

export const oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const zeroToNine = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
export const oneOrZero = [0, 1];
export const digits = "0123456789";
export const lowercase = "abcdefghijklmnopqrstuvwxyz";
export const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const letters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const b62 =
	"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const b64 =
	"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_";

export function sequence(len = 10) {
	var out = [];
	for (var i = 0; i < len; i++) {
		out.push(i);
	}
	return out;
}
export function randomString(
	str = letters,
	len = 8,
	prefix = "",
	postfix = ""
) {
	const lhs = sequence(len).reduce(
		(accum) => accum + str[Math.floor(Math.random() * str.length)],
		prefix
	);
	return lhs + postfix;
}
export function randomFromArray(arr = oneToTen) {
	return arr[Math.floor(Math.random() * arr.length)];
}
export function sampleFromArray(arr = oneToTen, num = 1) {
	var out = [];
	for (var i = 0; i < num; i++) {
		out.push(randomFromArray(arr));
	}
	return out;
}
export function humanFileSize(bytes, si) {
	if (isNaN(bytes)) return "";
	var thresh = si ? 1000 : 1024;
	if (Math.abs(bytes) < thresh) {
		return bytes + " B";
	}
	var units = si
		? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
		: ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
	var u = -1;
	do {
		bytes /= thresh;
		++u;
	} while (Math.abs(bytes) >= thresh && u < units.length - 1);
	return bytes.toFixed(1) + " " + units[u];
}
export const iconMap = (row) => {
	const defaultIconProps = {
		size: 16,
		style: { marginRight: 8, verticalAlign: "sub", flex: "0 0 auto" },
	};
	if (row.color) {
		defaultIconProps.color = row.color;
	}
	const defaultIcon = {
		icon: "file",
		iconComponent: <IconFile color="black" {...defaultIconProps} />,
	};

	if (row.original.type === "NoIcon") {
		return { icon: "", color: "", iconComponent: <></> };
	} else if (row.original.type === "Folder") {
		return {
			icon: "folder",
			iconComponent: (
				<IconFolderFilled
					color="var(--lw-folder-icon-yellow)"
					{...defaultIconProps}
				/>
			),
		};
	} else if (row.original.type === "Matter") {
		return {
			iconComponent: <IconBriefcase color="grey" {...defaultIconProps} />,
		};
	} else if (row.original.type === "Client") {
		// same icon as the "Clients" nav item in LeftSidebar.js
		return {
			iconComponent: (
				<IconUsersGroup color="grey" {...defaultIconProps} />
			),
		};
	} else if (row.original.type === "FirmDocs") {
		// same icon as the "Firm Documents" nav item in LeftSidebar.js
		return {
			iconComponent: (
				<IconFolderSymlink color="grey" {...defaultIconProps} />
			),
		};
	} else if (row.original.type === "Email") {
		return {
			icon: "envelope",
			iconComponent: <IconMail color="black" {...defaultIconProps} />,
		};
	} else if (row.original.type === "Note") {
		return {
			icon: "pencil-alt",
			iconComponent: <IconNote color="black" {...defaultIconProps} />,
		};
	} else if (row.original.type === "File") {
		const { extensionLowerCase } = splitFilename(row.original.filename);

		const map = getFileIconMap(defaultIconProps);

		return map[extensionLowerCase] || defaultIcon;
	} else {
		return defaultIcon;
	}
};
export const shortDateFormat = (val) => {
	var d = new Date(val);
	return d.toLocaleDateString("en-US");
};
export const shortDateFormatOffset = (val) => {
	var d = new Date(val);
	var offset = d.getTimezoneOffset() * 60000;
	var absoluteDate = new Date(d.getTime() + offset);
	return absoluteDate.toLocaleDateString("en-US");
};

export const mediumDateFormat = (val) => {
	var options = {
		hour: "numeric",
		minute: "numeric",
	};
	var date = new Date(val);

	return date.toLocaleDateString("en-US", options);
};
export const mediumDateFormatMinusTimezone = (val) => {
	var d = new Date(val);
	var options = {
		hour: "numeric",
		minute: "numeric",
	};
	var offset = d.getTimezoneOffset() * 60000;
	var absoluteDate = new Date(d.getTime() - offset);
	return absoluteDate.toLocaleDateString("en-US", options);
};
export const longDateFormat = (val) => {
	var options = {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
	};
	var date = new Date(val);

	return date.toLocaleDateString("en-US", options);
};
export const getScrollbarWidth = () => {
	// Create the measurement node
	var scrollDiv = document.createElement("div");
	scrollDiv.className = "scrollbar-measure";
	document.body.appendChild(scrollDiv);

	// Get the scrollbar width
	var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

	// Delete the DIV
	document.body.removeChild(scrollDiv);
	return scrollbarWidth;
};
export const documentLockTextMap = (lockedByDisplay) => ({
	0: [
		{
			text: `Currently Locked by ${lockedByDisplay || "???"}`,
			disabled: true,
		},
	],
	1: [
		{
			text: `Currently in use by ${lockedByDisplay || "???"}`,
			disabled: true,
		},
	],
	2: [
		{
			text: `Currently checked out to ${lockedByDisplay || "???"}`,
			disabled: true,
		},
	],
	3: [
		{
			text: `Currently checked out to & in use by ${
				lockedByDisplay || "???"
			}`,
			disabled: true,
		},
	],
	OUT_OF_BOUNDS: [
		{
			text: `Currently locked by ${lockedByDisplay || "???"}`,
			disabled: true,
		},
	],
});
export const getDocumentLockText = (status, displayName) => {
	return status >= 0 && status < 4
		? documentLockTextMap(displayName || "")[status][0].text
		: "Document is not locked";
};
const checkInIcon = (
	<IconLogin2
		color={"var(--lxw-main-500)"}
		size={16}
		style={{ verticalAlign: "sub" }}
	/>
);
const removeInUseIcon = (
	<IconUserX
		color={"var(--lxw-main-500)"}
		size={16}
		style={{ verticalAlign: "sub" }}
	/>
);
const checkOutIcon = (
	<IconLogout
		color={"var(--lxw-main-500)"}
		size={16}
		style={{ verticalAlign: "sub" }}
	/>
);
const unlockIcon = (
	<IconLockOpen
		color={"var(--lxw-main-500)"}
		size={16}
		style={{ verticalAlign: "sub" }}
	/>
);
export function getCheckoutMenuItems({
	lockedByDisplay,
	lockedBySub,
	lockStatus,
	documentID,
	basepath,
	userSub,
	fn,
	matterID,
	userCanOverrideDocumentLocks,
	isDisabled,
	disabledHoverText,
}) {
	const onSelect = (status) => () =>
		fn(documentID, status, basepath, matterID);
	/*

		Only lock statuses 0,1,2,3 should be set by the server.  Also,
		if a lockStatus is 1,2,3, this means the document is in a
		locked state and ought to have a lockedBySub set as well.  But
		mysql v5.7 does not support such a database-level constraint on
		multiple columns, so it is possible that a document could be in a
		"weird" state, and thus it should be handled as gracefully as
		possible by the browser



		This is what the menu options should show for a document, depending
		on its current lockStatus:

		0 - Check out (lock)
		
		1 - Check out
			Remove "in-use" lock
		
		2 - Check in (unlock)
		
		3 - Check in
			Remove "in-use"
			Check in & remove "in-use" (unlock file)



		This is the static text that should be displayed describing
		the documents current lock status:

		0 - 
		1 - Currently in use by Steve
		2 - Currently checked out to Steve
		3 - Currently checked out and in use by Steve


	*/
	const statusMap = {
		noLock: {
			0: [
				{
					text: "Check-Out (Lock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(2),
					iconComponent: checkOutIcon,
				},
			],
			OUT_OF_BOUNDS: [
				{
					text: "Unlock",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
		},
		lockedByMe: {
			0: [
				{
					text: "Check-In (Unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: checkInIcon,
				},
			],
			1: [
				{
					text: "Check-Out (Lock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(3),
					iconComponent: checkOutIcon,
				},
				{
					text: "Remove in-use (Unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: removeInUseIcon,
				},
			],
			2: [
				{
					text: "Check-In (Unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: checkInIcon,
				},
			],
			3: [
				{
					text: "Check-In",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(1),
					iconComponent: checkInIcon,
				},
				{
					text: "Remove in-use",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(2),
					iconComponent: removeInUseIcon,
				},
				{
					text: "Check-In and remove in-use (Unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
			OUT_OF_BOUNDS: [
				{
					text: "Unlock",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
		},
		lockedByOther: documentLockTextMap(lockedByDisplay),
		adminLockedByOther: {
			0: [
				{
					text: "Check in (unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
			1: [
				{
					text: "Remove in-use (unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: removeInUseIcon,
				},
			],
			2: [
				{
					text: "Check in (unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
			3: [
				{
					text: "Check in",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(1),
					iconComponent: checkInIcon,
				},
				{
					text: "Remove in-use",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(2),
					iconComponent: removeInUseIcon,
				},
				{
					text: "Check in and remove in-use (unlock)",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
			OUT_OF_BOUNDS: [
				{
					text: "Unlock",
					disabled: isDisabled,
					disabledHoverText,
					onSelect: onSelect(0),
					iconComponent: unlockIcon,
				},
			],
		},
	};

	const getLockedByMeMenu = (status) => {
		if (status >= 0 && status < 4) {
			return statusMap.lockedByMe[lockStatus];
		} else {
			//out of bounds lockStatus
			return statusMap.lockedByMe.OUT_OF_BOUNDS;
		}
	};
	const getLockedByOtherMenu = (status) => {
		if (status >= 0 && status < 4) {
			return statusMap.lockedByOther[lockStatus];
		} else {
			//out of bounds lockStatus
			return statusMap.lockedByOther.OUT_OF_BOUNDS;
		}
	};
	const getAdminLockedByOtherMenu = (status) => {
		const lockedByOtherMenu = getLockedByOtherMenu(status);
		if (status >= 0 && status < 4) {
			return lockedByOtherMenu.concat(
				statusMap.adminLockedByOther[lockStatus]
			);
		} else {
			//out of bounds lockStatus
			return lockedByOtherMenu.concat(
				statusMap.adminLockedByOther.OUT_OF_BOUNDS
			);
		}
	};
	const getNoLockedBySubMenu = (status) => {
		if (status === 0) {
			return statusMap.noLock[0];
		} else {
			return statusMap.noLock.OUT_OF_BOUNDS;
			//invalid state
		}
	};
	if (lockedBySub) {
		if (lockedBySub === userSub) {
			return getLockedByMeMenu(lockStatus);
		} else {
			if (userCanOverrideDocumentLocks) {
				return getAdminLockedByOtherMenu(lockStatus);
			} else {
				return getLockedByOtherMenu(lockStatus);
			}
		}
	} else {
		return getNoLockedBySubMenu(lockStatus);
	}
}
export function capitalize(str) {
	return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
}
// Naive space-split of the displayName field since we don't have separate first/last name fields in the DB
// Won't be correct for role-style names ("Law Clerk") and multi-word first names ("Mary Lou Johnson")
export function getFirstName(displayName) {
	return displayName ? displayName.split(" ")[0] : "";
}

const AI_OPENING_GREETINGS = [
	"Hi {NAME}, let me dig into that!",
	"Hi {NAME}, good question, checking into that now...",
	"Hi {NAME}, you bet, I'm on it!",
	"Great question, {NAME} — digging in now.",
	"On it, {NAME} — give me a moment.",
];

// The reply shown for the first query of a new AI chat, in place of a bare "Thinking...".
export function getAiOpeningGreeting(displayName) {
	return randomFromArray(AI_OPENING_GREETINGS).replace(
		"{NAME}",
		getFirstName(displayName)
	);
}
export const filmCreditsFlexHelper = (leftText, rightText) => {
	/*	
	film credits are aligned left for the character name, and right for the actor eg:

	Leia Organa.............Carrie Fisher
	Han Solo................Harrison Ford
*/
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
				gap: 8,
			}}
		>
			<span>{leftText}</span>
			<span style={{ textAlign: "right" }}>{rightText}</span>
		</div>
	);
};
export const splitFilename = (filename) => {
	const spl = filename.split(".");
	const extension = spl.length > 1 ? spl.pop() : "";
	const basename = spl.join(".");
	const extensionLowerCase = extension.toLowerCase();
	return { basename, extension, extensionLowerCase };
};

//having a '%' sign in the URL does not work properly for a number of reasons
//having to do with react-router-dom history library.  a side-effect of
//this workaround is that a user cannot name a folder PCT__SIGN
export const encodeFullpath = (fullpath) => {
	const encoded = fullpath
		.replace(/%/g, "PERCENT__SIGN")
		.replace(/#/g, "HASHTAG__SYMBOL");

	return encoded;
};
export const decodeFullpath = (fullpath) => {
	return fullpath
		? fullpath
				.replace(/PERCENT__SIGN/g, "%")
				.replace(/HASHTAG__SYMBOL/g, "#")
		: fullpath;
};
export const mapFirmDocsMatterID = (matterID, basepath) => {
	// both public and private firm docs have matterID=0.  For the search index,
	// we need to be able to query against just public or just private, so use -1
	// as the fake matterID for public firm docs
	return parseInt(matterID, 10) === 0
		? basepath.match(/^\/public/) || basepath.match(/^public/)
			? -1
			: 0
		: matterID;
};
export const getFirmDocsDisplayName = (matterID) => {
	if (matterID === 0) {
		return "Private Firm Docs";
	} else if (matterID === -1) {
		return "Public Firm Docs";
	} else {
		return "";
	}
};
export const getMatterLink = (matterID) => {
	if (matterID === 0) {
		return "/firmDocs/private/docs/";
	} else if (matterID === -1) {
		return "/firmDocs/public/docs/";
	} else {
		return `/matters/${matterID}/docs/`;
	}
};
export const pluralize = (noun, num) => noun + (num !== 1 ? "s" : "");
export const pluralizeWithNum = (noun, num) => num + " " + pluralize(noun, num);
export const trimFileName = (fn) => {
	if (typeof fn !== "string") {
		return "";
	}
	//Trim whitespace from filename and extension
	return fn.lastIndexOf(".") !== -1
		? fn.substring(0, fn.lastIndexOf(".")).trim() +
				"." +
				fn.substring(fn.lastIndexOf(".") + 1).trim()
		: fn.trim();
};
export function numberWithCommas(x) {
	if (x === 0) {
		return "0";
	} else {
		return x && x.toString
			? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			: "";
	}
}
export function convertToPDFAllowed(filename) {
	const { extensionLowerCase } = splitFilename(filename);
	return ["doc", "docx"].includes(extensionLowerCase);
}
export function ocrOnDemandAllowed(filename) {
	const { extensionLowerCase } = splitFilename(filename);
	return ["pdf"].includes(extensionLowerCase);
}
/**
 * Determines if OCR is disabled for a document and provides appropriate hover text
 * @param {Object} params
 * @param {Object} [params.userRights] - User rights object (checks CAN_REQUEST_OCR_MANUALLY)
 * @param {string} [params.lockedBySub] - Sub of user who has document locked (if any) - used in DocumentContextMenu
 * @param {string} [params.cognitoSub] - Current user's cognito sub - used with lockedBySub
 * @param {boolean} [params.documentNotInUse] - Whether document is not in use (lockStatus 0 or 2) - used in DocumentProperties
 * @param {boolean} [params.ableToModify] - Whether user is able to modify (not locked or locked by self) - used in DocumentProperties
 * @param {boolean} params.isOcrEnabled - Whether OCR is enabled for the firm
 * @param {boolean} params.isTenantOverOcrLimit - Whether firm is over OCR limit
 * @param {boolean} params.documentActionsAreDisabled - Whether document actions are disabled (e.g., matter deleted)
 * @param {string} params.documentActionsAreDisabledHoverText - Hover text for disabled document actions
 * @returns {Object} { disabled: boolean, disabledHoverText: string }
 */
export function ocrIsDisabledForDocument({
	lockedBySub,
	cognitoSub,
	documentNotInUse,
	ableToModify,
	isOcrEnabled,
	isTenantOverOcrLimit,
	documentActionsAreDisabled,
	documentActionsAreDisabledHoverText,
	userRights, // userRights.CAN_REQUEST_OCR_MANUALLY === false should disable OCR UI options
}) {
	// Check conditions in priority order (most fundamental to most specific)

	// 1. User lacks permission to request OCR manually (most fundamental - no point checking other conditions)
	if (userRights && userRights.CAN_REQUEST_OCR_MANUALLY === false) {
		return {
			disabled: true,
			disabledHoverText:
				"You do not have permission to request OCR. Please contact your Firm Administrator for more information.",
		};
	}

	// 2. Document actions are disabled (e.g., matter is deleted, folder in trash)
	if (documentActionsAreDisabled) {
		return {
			disabled: true,
			disabledHoverText: documentActionsAreDisabledHoverText,
		};
	}

	// 3. Firm does not have OCR enabled
	if (!isOcrEnabled) {
		return {
			disabled: true,
			disabledHoverText:
				"Your firm does not have OCR enabled. Please contact the Uptime Help Desk for more information.",
		};
	}

	// 4. Firm is over OCR limit
	if (isTenantOverOcrLimit) {
		return {
			disabled: true,
			disabledHoverText:
				"You have reached your monthly OCR Limit. Please contact your Firm Administrator for more information.",
		};
	}

	// 5. Document lock checks (two different patterns used in different components)

	// Pattern A: DocumentProperties uses documentNotInUse and ableToModify
	if (
		typeof documentNotInUse !== "undefined" &&
		typeof ableToModify !== "undefined"
	) {
		// Document is in use and user can modify (locked by current user)
		if (!documentNotInUse && ableToModify) {
			return {
				disabled: true,
				disabledHoverText:
					"You have this document open in the launcher",
			};
		}
		// Document is in use and user cannot modify (locked by someone else)
		if (!documentNotInUse && !ableToModify) {
			return {
				disabled: true,
				disabledHoverText: "This document is locked by another user",
			};
		}
	}

	// Pattern B: DocumentContextMenu uses lockedBySub and cognitoSub
	if (lockedBySub) {
		// Document is locked by current user
		if (lockedBySub === cognitoSub) {
			return {
				disabled: true,
				disabledHoverText:
					"You have this document open in the launcher",
			};
		}
		// Document is locked by another user
		return {
			disabled: true,
			disabledHoverText: "This document is locked by another user",
		};
	}

	// No conditions met - OCR is enabled
	return {
		disabled: false,
		disabledHoverText: "",
	};
}

/**
 * Determines if delete version is disabled for a document and provides appropriate hover text
 * @param {Object} params
 * @param {Object} [params.userRights] - User rights object (checks CAN_DELETE_DOCUMENT_VERSIONS)
 * @param {boolean} params.documentActionsAreDisabled - Whether document actions are disabled (e.g., matter deleted)
 * @param {string} params.documentActionsAreDisabledHoverText - Hover text for disabled document actions
 * @returns {Object} { disabled: boolean, disabledHoverText: string }
 */
export function deleteVersionIsDisabled({
	userRights,
	documentActionsAreDisabled,
	documentActionsAreDisabledHoverText,
}) {
	// Check conditions in priority order

	// 1. User lacks permission to delete document versions
	if (userRights && userRights.CAN_DELETE_DOCUMENT_VERSIONS !== true) {
		return {
			disabled: true,
			disabledHoverText:
				"You do not have permission to delete document versions. Please contact your Firm Administrator for more information.",
		};
	}

	// 2. Document actions are disabled (e.g., matter is deleted, folder in trash)
	if (documentActionsAreDisabled) {
		return {
			disabled: true,
			disabledHoverText: documentActionsAreDisabledHoverText,
		};
	}

	// No conditions met - delete version is enabled
	return {
		disabled: false,
		disabledHoverText: "",
	};
}

const literaWordFileTypes = ["doc", "docx", "rtf", "pdf", "wpd"];
const literaExcelFileTypes = ["xls", "xlsx", "xlsm", "xlsb"];
const literaPowerpointFileTypes = [
	"ppt",
	"pps",
	"pptx",
	"pptm",
	"ppsx",
	"ppsm",
];
const supportedLiteraFileTypes = [
	...literaWordFileTypes,
	...literaExcelFileTypes,
	...literaPowerpointFileTypes,
];
export function isFileTypeCompatibleWithLitera(filename) {
	if (!filename) {
		return false;
	}
	const { extensionLowerCase } = splitFilename(filename);
	return supportedLiteraFileTypes.includes(extensionLowerCase);
}

const supportedDraftableFileTypes = [
	"docx",
	"docm",
	"doc",
	"rtf",
	"pdf",
	"txt",
	"pptx",
	"pptm",
	"ppt",
];

export function isFileTypeCompatibleWithInline(filename) {
	if (!filename) {
		return false;
	}
	const { extensionLowerCase } = splitFilename(filename);
	return supportedDraftableFileTypes.includes(extensionLowerCase);
}

export function isPlatformMac() {
	return navigator.platform.indexOf("Mac") > -1;
}

export function getDocumentPreviewType(filename) {
	const { extensionLowerCase } = splitFilename(filename);
	if (["pdf"].includes(extensionLowerCase)) {
		return "PDF_INLINE";
	} else if (["docx"].includes(extensionLowerCase)) {
		return "DOCX_INLINE";
	} else if (["xlsx", "xls", "xlsb", "csv"].includes(extensionLowerCase)) {
		return "EXCEL_INLINE";
	} else if (
		["jpg", "jpeg", "png", "bmp", "gif", "webp", "svg"].includes(
			extensionLowerCase
		)
	) {
		return "IMAGE_INLINE";
	} else {
		return "SEARCH_INDEX_CONTENT";
	}
}

//.tif files can only be displayed inline by Safari as of Feb 2024
export function canShowInlineImagePreview(filename) {
	const { extensionLowerCase } = splitFilename(filename);
	return ["jpg", "jpeg", "png", "bmp", "gif", "webp", "svg"].includes(
		extensionLowerCase
	);
}

export function getDisabledFeatureCodeMessage(featureCode) {
	if (featureCode === "literaDocumentCompareVisible") {
		return errorCodes["TENANT_LITERA_DOCUMENT_COMPARE_NOT_VISIBLE"]
			?.description;
	} else if (featureCode === "literaDocumentCompareEnabled") {
		return errorCodes["TENANT_LITERA_DOCUMENT_COMPARE_NOT_ENABLED"]
			?.description;
	} else if (featureCode === "inlineDocumentCompareEnabled") {
		return errorCodes["TENANT_INLINE_DOCUMENT_COMPARE_NOT_ENABLED"]
			?.description;
	} else {
		console.warn(
			"getDisabledFeatureCodeMessage: unknown featureCode",
			featureCode
		);
		return `Your firm does not have ${featureCode} enabled. Please contact the Uptime Help Desk for more information.`;
	}
}

export function getLiteraDisabledHoverText({
	isLiteraCompareVisible,
	isLiteraCompareEnabled,
	isAlreadySelectedForDocCompare,
	canAddToLiteraCompare,
	launcherInstalled,
	documentActionsAreDisabled,
	documentActionsAreDisabledHoverText,
}) {
	if (isPlatformMac()) {
		return "Litera Compare integration is only available on Windows.";
	} else if (!launcherInstalled) {
		return "Please install the LexWorkplace Launcher to Compare with Litera";
	} else if (documentActionsAreDisabled) {
		return documentActionsAreDisabledHoverText;
	} else if (!isLiteraCompareEnabled) {
		return getDisabledFeatureCodeMessage("literaDocumentCompareEnabled");
	} else if (!isLiteraCompareVisible) {
		return getDisabledFeatureCodeMessage("literaDocumentCompareVisible");
	} else if (!canAddToLiteraCompare) {
		return "You have started an Inline Document comparison. Please reset the comparison to start a comparison with Litera.";
	} else if (isAlreadySelectedForDocCompare) {
		return "This document has already been selected for comparison.  Please select a second document to compare.  (If you wish to compare different versions of the same document, you can do so from the Document Properties screen.)";
	} else {
		return null;
	}
}

export function getInlineDisabledHoverText({
	isInlineCompareEnabled,
	isAlreadySelectedForDocCompare,
	canAddToInlineCompare,
	documentActionsAreDisabled,
	documentActionsAreDisabledHoverText,
}) {
	if (!isInlineCompareEnabled) {
		return getDisabledFeatureCodeMessage("inlineDocumentCompareEnabled");
	} else if (documentActionsAreDisabled) {
		return documentActionsAreDisabledHoverText;
	} else if (!canAddToInlineCompare) {
		return "You have started a Litera Document comparison. Please reset the comparison to start an Inline Comparison.";
	} else if (isAlreadySelectedForDocCompare) {
		return "This document has already been selected for comparison.  Please select a second document to compare.  (If you wish to compare different versions of the same document, you can do so from the Document Properties screen.)";
	} else {
		return null;
	}
}

export function msToTime(ms) {
	let seconds = (ms / 1000).toFixed(1);
	let minutes = (ms / (1000 * 60)).toFixed(1);
	let hours = (ms / (1000 * 60 * 60)).toFixed(1);
	let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
	if (seconds < 60) return seconds + " Sec";
	else if (minutes < 60) return minutes + " Min";
	else if (hours < 24) return hours + " Hrs";
	else return days + " Days";
}

// common functions for permissions
export const makeDictOfDisplayNamesBySub = (allUsers) => {
	var out = {};
	allUsers.forEach((u) => {
		out[u.sub] = u.displayName;
	});
	return out;
};
export const makeDictOfGroupNamesByID = (allGroups) => {
	var out = {};
	allGroups.forEach((g) => {
		out[g.id] = { name: g.name, type: g.type };
	});
	return out;
};

export const permissionFeatureGlobalSettingOptions = [
	{ value: "allUsers", label: "All Users" },
	{ value: "specifiedUsers", label: "Only Specified Users" },
];

export const permissionFeatureGlobalSettingLookup = {
	allUsers: 0,
	specifiedUsers: 1,
};
export const matterPermissionGlobalSettingOptions = [
	{ value: "allUsers", label: "All Users" },
	{ value: "specifiedUsers", label: "Only Specified Users" },
];
export const matterPermissionGlobalSettingLookup = {
	allUsers: 0,
	specifiedUsers: 1,
};
export const allowListDropdownMap = (user, subLookup) => ({
	value: user.userSub,
	label: subLookup[user.userSub],
});

export const groupListDropdownMap = (group, groupLookup) => ({
	value: group.groupID,
	label: groupLookup[group.groupID].name, //group.name,
	isFixed: groupLookup[group.groupID].type === "FIRM_ADMIN",
	memberNames: groupLookup[group.groupID].memberNames,
});

export const findAdminGroups = (availableGroups) => {
	return availableGroups.filter((g) => g.isFixed);
};

export function makeDebouncedFunction(func, waitTimeMS) {
	let timeout;
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, waitTimeMS);
	};
}

export function clamp(num, min, max) {
	return Math.min(Math.max(num, min), max);
}

export function setHtmlDocumentTitle() {
	let titlePart = "LexWorkplace";
	let branchPart = "";
	if (import.meta.env.VITE_ENVIRONMENT === "local") {
		// Detect worktree from hostname (e.g., alpha.lxw.local → "A")
		const hostname = window.location.hostname;
		const worktreeMap = {
			alpha: "A",
			bravo: "B",
			charlie: "C",
			delta: "D",
		};
		const subdomain = hostname.split(".")[0];
		const suffix = worktreeMap[subdomain] || "";
		titlePart = `LX Local${suffix}`;
	} else {
		titlePart = "LexWorkplace";
	}
	if (import.meta.env.VITE_ENVIRONMENT !== "production") {
		if (
			import.meta.env.VITE_ENVIRONMENT === "development" &&
			buildData.branch === "master"
		) {
			// the development env, when running master should show as "development"
			branchPart = " (dev)";
		} else {
			branchPart = ` (${buildData.branch})`;
		}
	}

	document.title = titlePart + branchPart;
}

export function formatDocumentVersionLabel(label) {
	if (label.minor === null || label.minor === undefined) {
		return `v${label.major}`;
	}
	return `v${label.major}.${label.minor}`;
}
